import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PartnerCreateForm } from "Partner/Components/Form/CreateForm";
import { PageContainer } from "Shared/Components/Container";
import { Box, Typography } from "@mui/material";

const partnerCreateResources = Resources.base.partner.detail;

export const PartnerCreatePage = () => {
	const { t } = useResource();
	return (
		<PageContainer
			title="Add partners"
			description="Create and add new partner details"
		>
			<Box display="flex" flexDirection="column" gap={6}>
				<Typography variant="h1">
					{t(partnerCreateResources.create.title)}
				</Typography>
				<PartnerCreateForm />
			</Box>
		</PageContainer>
	);
};
